const colorHandler =(value :number) => {
    if(value >= 60)
    {
    return "#228B22"
     }
    else if (value < 60 && value >=30)
    { 
        return "#FFA500"
     } 
    else {
       return "#ff3333"
    }
}
 const defaultColor = "#ff3333"
 const activeColor ="#F6eec0"

export {colorHandler,defaultColor ,activeColor}
